<template>
    <section class="pdtb3">
        <div class="container video-player pr-player-canvas" v-if="sources !== null" :class="[{ playing: is_playing, transition: in_transition }]">

            <div class="video-player-overlay intro" v-if="!is_lib_vid">
                <span>When you're ready...</span>
                <div @click="togglePlay()"></div>
                <span class="mt100"><small>Note: you can change your selected warmup routine in <a href="/account/settings">your account settings</a>.</small></span>
            </div>
            <div class="video-player-overlay intro" v-if="is_lib_vid">
                <h1>{{ is_lib_vid.video_data.title }}</h1>
                <span>Click below when you're ready.</span>
                <div @click="togglePlay()"></div>
                <span v-if="is_lib_vid.video_data.props.length" class="small mt300 mb200">You'll need the following before you start:</span>
                <ul class="prop-list" v-if="is_lib_vid.video_data.props.length">
                    <li v-for="prop in is_lib_vid.video_data.props" class="prop-label invert" :class="prop"></li>
                </ul>
            </div>

            <div class="video-player-overlay outro" v-if="!is_lib_vid">

                <small class="ping-state drill" :class="ping_state"></small>

                <small v-if="insufficient_watch_time">Sorry, not enough watch time was logged to record a completion!</small>

                <small v-if="ping_state === 'error'" class="ping-error ping-status">Please check your connection and <span @click="pingSequenceCompleted(is_lib_vid)">click here to retry</span></small>

                <small><a href="#" @click.prevent="togglePlay()">Click here to repeat these moves</a></small>
                <small>Finding this too easy? <a href="/builder">Level up now!</a> <br>Alternatively: Add custom-made routines from <a href="/workout-library">the library</a> into your
                    <a href="/calendar">calendar</a>.</small>
            </div>

            <div class="video-player-overlay outro" v-if="is_lib_vid">

                <small class="ping-state lib" :class="ping_state"></small>

                <small v-if="insufficient_watch_time">Sorry, not enough watch time was logged to record a completion!</small>

                <small v-if="ping_state === 'error'" class="ping-error ping-status">Please check your connection and <span @click="pingSequenceCompleted(is_lib_vid)">click here to retry</span></small>

                <small><a href="#" @click.prevent="togglePlay()">Click here to repeat this workout</a></small>
                <small>Remember, you can <a href="/private-library">customise your private library</a> and
                    <a href="/calendar">build your own monthly schedule</a> at any time.</small>
            </div>

            <div class="video-player-overlay autoplay-error">
                <small><i class="fa fa-exclamation-triangle"></i> Error playing next video. Your browser might not support video autoplay.
                    <br>Click the button below to attempt manual playback.</small>
                <div @click="play()"></div>
            </div>

            <div class="player-head">
                <span>{{ title_text }}</span>
            </div>

            <span id="skip-start-btn" class="main-player" :class="{show: show_skip_start_btn, initialized: skip_start_btn_initialized}" @click="skipTo"><span>skip intro</span></span>

<vue-plyr ref="plyr" :options="playerOptions" crossorigin="anonymous">
    <video></video>
</vue-plyr>

            <div class="iwd-player-controls">
                <button :class="{ disabled: (current_drill_index === 0) }" @click="playPrevious()"></button>
                <button :class="[{ disabled: false, play: !is_playing, pause: is_playing }]" @click="togglePlay()"></button>
                <button :class="{ disabled: (current_drill_index === (sources.length - 1)) }" @click="playNext()"></button>
            </div>

        </div>
    </section>
</template>

<script>

var emitter = require('tiny-emitter/instance');

export default {

	data(){
        return {
            playerOptions: {
                controls: [
                    'progress',
                    'volume',
                    'play',
                    'fullscreen',
                    'settings'
                ],
                settings: [
                    'quality'
                ],
                quality: {
                	'default': 1080
                },
                storage: {
                	'enabled': false
                }
            },
            is_playing: false,
            is_seeking: false,
            in_transition: false,
            ping_state: 'ready',
            current_drill_index: 0,
            is_lib_vid: false,
            next_day: null,
            sources: null,
            start_time: false,
            insufficient_watch_time: false,
            show_skip_start_btn: false,
            skip_start_btn_initialized: false
        }
    },
    computed: {
        player () {
            return this.$refs.plyr.player
        },
        title_text(){
            if(this.in_transition || this.is_seeking || !this.sources) return 'Loading...';

            const vid_title = this.sources[this.current_drill_index].title;

            if(this.is_lib_vid)
            {
                return this.is_playing ? 'Now playing (from the library): ' + vid_title : 'Ready';
            }

            if(this.is_playing && this.current_drill_index === 0)
            {
                return vid_title;
            }

            return this.is_playing ? 'Now playing ('+(this.current_drill_index)+'/5): '+ vid_title : 'Ready';
        }
    },
    mounted(){

        const time_now = Date().toString();

        this.getFirstOfSequenceData(time_now, false).then((response)=>{

            this.sources = response.data.sources;

            if(!this.sources){
                alert('No sequence found. Please make sure you have at least one chapter selected!');
                window.location.href = '/builder';
                return false;
            }

            if(response.data.is_lib_vid)
            {
                this.is_lib_vid = response.data.is_lib_vid;
                this.skip_start = response.data.skip_start;

            }else{

                this.getRestOfSequenceData(time_now, false).then((response)=>{
                    for(let i=0; i<response.data.sources.length; i++){
                        this.sources.push(response.data.sources[i]);
                    }
                });

            }

            this.hideLoader();

            this.$nextTick(()=>{
                this.player.source = this.sources[this.current_drill_index];

                emitter.on('windowResized', ()=>{
                    this.allowHeightAdjust();
                });

                this.player.on('playing',()=>{
                	this.fixHeight();
                    this.is_playing = true;
                    this.in_transition = false;
                    $('.video-player-overlay.autoplay-error').hide();
                    $('.video-player-overlay').fadeOut(1000);
                	this.skip_start_btn_initialized = true;
                    this.checkSkipStartVisibility();
                });
                this.player.on('pause',()=>{
                    this.is_playing = false;
                });
                this.player.on('ended', ()=>{

                    this.in_transition = true;
                    // this.current_drill_index = this.current_drill_index === (this.sources.length - 1) ? 0 : this.current_drill_index

                    // setTimeout(()=>{
                        if(this.current_drill_index === (this.sources.length - 1)){

                            if(this.player.fullscreen.active){
                                this.player.fullscreen.exit();
                            }

                            this.is_playing = false;
                            this.current_drill_index = 0;
                            this.player.source = this.sources[this.current_drill_index];
                            $('.video-player-overlay.outro').css('display', 'flex').hide().fadeIn(1000);

                            const time_now = Math.round(Date.now() / 1000);

                            const watch_time = time_now - this.start_time;

                            let required_watch_time = this.is_lib_vid ? this.is_lib_vid.video_data.duration / 3 : 180;

                            if(process.env.NODE_ENV === 'development')
                            {
                                required_watch_time = 1;
                            }

                            if(watch_time < required_watch_time)
                            {
                                this.insufficient_watch_time = true;
                            }else{
                                this.insufficient_watch_time = false;
                                this.pingSequenceCompleted(this.is_lib_vid, watch_time);
                            }

                            return;
                        }else{
                            this.playNext();
                        }
                    // },100);
                });

            });
        });
    },
    methods: {
		play()
        {
            this.player.play().then(()=>{

                if(!this.start_time)
                {
                    this.start_time = Math.round(Date.now() / 1000);
                }

            }).catch((error)=>{
            	console.log('autoplay error: ' + error);
                this.throwAutoPlayError();
            });
        },
        checkSkipStartVisibility()
        {
            if(this.skip_start && (this.player.currentTime < this.skip_start))
            {
                this.show_skip_start_btn = true;
                this.runCycleToRemoveSkipStartBtn();
            }else {
                this.show_skip_start_btn = false;
            }
        },
        runCycleToRemoveSkipStartBtn()
        {
            clearTimeout(this.run);
            this.run = setTimeout(()=>{

                if(!this.player.playing)
                    return false;

                if(this.player.currentTime >= this.skip_start){
                    this.show_skip_start_btn = false;
                    return false;
                }
                this.runCycleToRemoveSkipStartBtn();
            },1000);
        },
        skipTo()
        {
            this.player.currentTime = this.skip_start;
        },
        throwAutoPlayError()
        {
        	setTimeout(()=>{
        		if(!this.player.playing){
                    this.is_playing = false;
                    this.in_transition = false;
                    $('.video-player-overlay').hide();
                    $('.video-player-overlay.autoplay-error').css('display', 'flex');
                }
            },1000);
        },
        playPrevious(){
            if(this.current_drill_index === 0) return false;
            this.current_drill_index--;
            this.player.source = this.sources[this.current_drill_index];
            this.play();
        },
        playNext(){
            if(this.current_drill_index === (this.sources.length - 1)) return false;
            this.current_drill_index++;
            this.player.source = this.sources[this.current_drill_index];
            this.play();
        },
        togglePlay(){
            this.is_playing ? this.player.pause() : this.play();
        },
        allowHeightAdjust(){
            const $el = $('.container.video-player');
            $el.css('height', 'auto');
            this.$nextTick(()=>{
                this.fixHeight();
            })
        },
        fixHeight(){
            const $el = $('.container.video-player');
            const h = $el.outerHeight();
            $el.css('height', h + 'px');
        }
    }
}

</script>
